class AccountMenu
    constructor: (el) ->
        @.$el = el
        @.$button = @.$el.querySelector '.account-menu__button'
        @.$logOutButton = @.$el.querySelector '.account-menu__log-out'

        @.loggedIn = @.$el.classList.contains 'account-menu--logged-in'
        @.loginOverlayId = @.$el.dataset?.loginOverlayId ? false
        @.logOutViaApi = @.$el.classList.contains 'account-menu--logout-via-api'
        @.logOutLink = if @.$logOutButton && @.logOutViaApi then @.$logOutButton.href else false
        @.open = @.$el.classList.contains 'account-menu--open'

        @.InitEvents()
        @.$el.classList.add 'account-menu--bound'
        return
    
    InitEvents: ->
        self = @
        @.$button.addEventListener 'click', (e) ->
            if self.loggedIn
                self.SetMenuState !self.open
            else
                if self.loginOverlayId
                    document.getElementById self.loginOverlayId
                        .dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
            return
        if @.logOutViaApi && @.$logOutButton
            @.$logOutButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.LogOutViaApi()
                return
        return

    LogOutViaApi: ->
        if @.logOutLink
            request = window.appUtils.XMLHttpRequest 'GET', @.logOutLink
                , ->
                    window.location.reload()
                    return
            
        return
    
    SetMenuState: (open) ->
        @.open = open
        if @.open
            @.$el.classList.add 'account-menu--open'
        else
            @.$el.classList.remove 'account-menu--open'
        return

BindAccountMenus = ->
    document.querySelectorAll '.account-menu:not(.account-menu--bound)'
        .forEach (el) ->
            new AccountMenu el
            return
    return

window.addEventListener 'bind-components', BindAccountMenus